const data = state => param => state.data[param];
const dataobject = state => state.data;
const actiondata = state => param => state.actiondata[param]
const actiondataobject = state => state.actiondata




export default {
  data,
  dataobject,
  actiondata,
  actiondataobject

};